module.exports = __webpack_public_path__ + "media/images/icon_a-4f002fc108e2a9ee8b3192b4d7e8d60b.png";